export default __webpack_public_path__ + "static/media/cookie.afee9399.svg";